var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AccountType } from "../../../../helpers/getAccountType";
import { CardBodyInnerWrapper } from "../CardBody.style";
import LoanBodySection from "../LoanBodySection/LoanBodySection";
import SecuredLoanBodySection from "../SecuredLoanBodySection/SecuredLoanBodySection";
import DualCardBodySection from "../DualCardBodySection/DualCardBodySection";
import i18n from "../../../../strings/i18n";
var CardBody = function (_a) {
    var _b;
    var accountType = _a.accountType, bodyData = _a.bodyData;
    if (!accountType || !Object.values(AccountType).includes(accountType)) {
        return _jsx("p", { children: i18n({ labels: "noAccountCard" }) });
    }
    var bodySection = (_b = {},
        _b[AccountType.LOAN] = _jsx(LoanBodySection, __assign({}, bodyData)),
        _b[AccountType.PAY_IN_4] = _jsx(LoanBodySection, __assign({}, bodyData)),
        _b[AccountType.SECURED_INSTALLMENT_LOAN] = (_jsx(SecuredLoanBodySection, __assign({}, bodyData))),
        _b[AccountType.CARD] = _jsx(DualCardBodySection, __assign({}, bodyData)),
        _b);
    return (_jsx(CardBodyInnerWrapper, __assign({ isLoanPaidOffForSI: bodyData.isLoanPaidOffForSI }, { children: bodySection[accountType] })));
};
export default CardBody;
//# sourceMappingURL=CardBodySection.js.map